import { useState, useEffect } from 'react';

/**
 * ProgressBar - 進捗バーコンポーネント
 *
 * みんなで達成のゴール進捗を表示する。
 * バーの右側に「current / total」を表示する。
 *
 * アニメーション仕様:
 * - マウント時・current/total 変化時: 0% → 目標 % へ transition
 * - ラリー切り替え時は GoalBanner 側で key を渡すことでリセット可能
 */
const ProgressBar = ({ current, total, label }) => {
  const targetPct = total > 0 ? Math.min((current / total) * 100, 100) : 0;
  const isComplete = targetPct >= 100;

  // アニメーション用: マウント直後は 0% → 次フレームで目標値へ
  const [displayPct, setDisplayPct] = useState(0);

  useEffect(() => {
    // 1フレーム遅らせることで CSS transition が確実に発火する
    const id = requestAnimationFrame(() => {
      setDisplayPct(targetPct);
    });
    return () => cancelAnimationFrame(id);
  }, [targetPct]);

  return (
    <div className="w-full">
      {label && (
        <p className="mb-1 text-xs text-gray-600">{label}</p>
      )}
      <div className="flex items-center gap-2">
        {/* バー本体 */}
        <div className="relative h-5 flex-1 overflow-hidden rounded-full bg-gray-200">
          <div
            className={`h-full rounded-full transition-all duration-700 ease-out ${
              isComplete ? 'bg-green-500' : 'bg-amber-400'
            }`}
            style={{ width: `${displayPct}%` }}
          />
        </div>
        {/* 数値（バー右側） */}
        <span className="flex-shrink-0 text-xs font-bold text-gray-700">
          {current} / {total}
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;

